export default {
    showVariationsModal: {
        copy: 'Copiar',
        contentVariation: 'Variação de conteúdo',
        chosenContent: 'Conteúdo escolhido',
        chosenContentPlaceholder: 'Por favor, insira',
        continue: 'Continuar',
        generateNewContent: 'Gerar novo conteúdo',
        type: 'Tipo:',
        contentTitle: 'Título:',
        descriptionLabel: 'Descrição:',
        keywordsLabel: 'Palavras-chave:',
        writingTone: 'Tom de escrita:',
        context: 'Contexto:',
        cancel: 'Cancelar',
        emailBuilderTooltip: 'Custom values for sender and recipient is added in the content.',
    },
};
